// extracted by mini-css-extract-plugin
export var createdDate = "_h8-1";
export var divider = "_h8-2";
export var headerDivider = "_h8-3";
export var messagesCard = "_h8-0";
export var messagesContainer = "_h8-6";
export var messagesContainerWrapper = "_h8-4";
export var showLeftPanelButton = "_h8-8";
export var topButtons = "_h8-7";
export var withPadding = "_h8-5";